import React from 'react';

export default function Blogs() {
  const blogs = [
    {
      title: 'Secure Amazon SageMaker Studio presigned URLs Part 3: Multi-account private API access to Studio',
      description: 'How to extend a private API to generate SageMaker Studio presigned URLs across multiple AWS accounts for different LOBs, with secure routing using Transit Gateway and VPC endpoints.',
      url: 'https://aws.amazon.com/blogs/machine-learning/secure-amazon-sagemaker-studio-presigned-urls-part-3-multi-account-private-api-access-to-studio/',
      type: 'AWS Machine Learning Blog',
      icon: '🔒',
    },
    {
      title: 'Introducing the Amazon Comprehend flywheel for MLOps',
      description: 'A one-stop MLOps feature for Amazon Comprehend models that automates training, evaluation, and deployment—from data ingestion to real-time inference with custom classification and entity recognition.',
      url: 'https://aws.amazon.com/blogs/machine-learning/introducing-the-amazon-comprehend-flywheel-for-mlops/',
      type: 'AWS Machine Learning Blog',
      icon: '🔄',
    },
    {
      title: 'Governing the ML lifecycle at scale, Part 2: Multi-account foundations',
      description: 'Guidance for implementing multi-account foundation architecture for ML workloads using AWS Control Tower, Security Reference Architecture, Service Catalog, and hub-and-spoke network design.',
      url: 'https://aws.amazon.com/blogs/machine-learning/governing-the-ml-lifecycle-at-scale-part-2-multi-account-foundations/',
      type: 'AWS Machine Learning Blog',
      icon: '☁️',
    },
    {
      title: "Part 5: BBVA's unified console: Key to successful global platform deployment",
      description: 'How BBVA leveraged AWS to build operations capabilities for their global Analytics, Data, AI (ADA) platform—unified console, deployment architecture, and observability at scale.',
      url: 'https://aws.amazon.com/blogs/industries/part-5-bbvas-unified-console-key-to-successful-global-platform-deployment/',
      type: 'AWS for Industries Blog',
      icon: '🏦',
    },
    {
      title: 'Deploy detective attribute-based access controls for public subnets by using AWS Config',
      description: 'AWS Prescriptive Guidance pattern for detecting noncompliant resources in public subnets using AWS Config custom rules and ABAC—alerting when resources other than load balancers or NAT gateways are deployed.',
      url: 'https://docs.aws.amazon.com/prescriptive-guidance/latest/patterns/deploy-detective-attribute-based-access-controls-for-public-subnets-by-using-aws-config.html',
      type: 'AWS Prescriptive Guidance',
      icon: '🛡️',
    },
  ];

  return (
    <section id="blogs" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Blog & Publications
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto">
            AWS blog posts and architecture patterns I&apos;ve authored on cloud, MLOps, and enterprise platforms
          </p>
        </div>

        <div className="space-y-6">
          {blogs.map((blog, index) => (
            <a
              key={index}
              href={blog.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-blue-500 transition group"
            >
              <div className="flex flex-col sm:flex-row sm:items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-2xl group-hover:bg-blue-200 transition">
                  {blog.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-gray-100 text-gray-600 text-xs font-medium rounded">
                      {blog.type}
                    </span>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 group-hover:text-primary transition">
                    {blog.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 mb-3">
                    {blog.description}
                  </p>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary">
                    Read on AWS
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
